import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { ComplicatieType, Ingreep } from '@common/customControls/bariatrics';
import { getProcessActivityAssetsSchema } from '@common/validation/processActivityAsset';
import { gewichtInKgSchema } from '@common/validation/schemas';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaConditionalSchema } from '@common/validation/utils/getTextAreaConditionalSchema';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';
import { getTextInputStringSchema } from '@common/validation/utils/getTextInputStringSchema';
import type { BariPostEnrollmentDataV1 } from './bariPostEnrollmentDataV1';

export const bariPostEnrollmentFinalV1: TypedSchema<BariPostEnrollmentDataV1> = {
    assets: getProcessActivityAssetsSchema(),
    bijzonderheden: Koi.boolean(),
    bijzonderheden_labwaarden: Koi.boolean(),
    bijzonderheden_labwaarden_omschrijving: getTextAreaConditionalSchema('bijzonderheden_labwaarden'),
    bijzonderheden_omschrijving: getTextAreaConditionalSchema('bijzonderheden'),
    complicatie_type: Koi.when('complicaties', {
        is: true,
        otherwise: Koi.valid(null),
        then: Koi.koi().enum(ComplicatieType),
    }),
    complicaties: Koi.boolean(),
    complicaties_omschrijving: Koi.when('complicatie_type', {
        is: ComplicatieType.overig,
        otherwise: getTextAreaStringSchema(true),
        then: getTextAreaStringSchema(),
    }),
    datum_lab_geprikt: Koi.koi().todayOrBefore().allow(null),
    datum_operatie: Koi.koi().todayOrBefore().allow(null),
    gewicht_voor_operatie: gewichtInKgSchema,
    ingreep: Koi.koi().enum(Ingreep),
    naam_chirurg: getTextInputStringSchema(),
};

export const bariPostEnrollmentDraftV1 = addAllowNull(
    {
        ...bariPostEnrollmentFinalV1,
        assets: getProcessActivityAssetsSchema(),
        bijzonderheden_labwaarden_omschrijving: getTextAreaConditionalSchema('bijzonderheden_labwaarden', true),
        bijzonderheden_omschrijving: getTextAreaConditionalSchema('bijzonderheden', true),
        complicatie_type: Koi.when('complicaties', {
            is: true,
            otherwise: Koi.valid(null),
            then: Koi.koi().enum(ComplicatieType).allow(null),
        }),
        complicaties_omschrijving: Koi.when('complicatie_type', {
            is: ComplicatieType.overig,
            otherwise: getTextAreaStringSchema(true),
            then: getTextAreaStringSchema(true),
        }),
    },
    ['assets']
);

export const bariPostEnrollmentDraftSchemaV1 = Koi.object(bariPostEnrollmentDraftV1);
export const bariPostEnrollmentFinalSchemaV1 = Koi.object(bariPostEnrollmentFinalV1);
